import React, { Component } from "react"
import { Table, Row, message } from "antd"
import cx from "classnames"
// import config from "app/config"
import { observer, inject } from "mobx-react"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"
import { disposeFilename } from "app/vendor/util"
import Highlighter from "app/components/normal/HighLighter"
import highlightable from "app/utils/highlightable"
import editAbleIcon from "app/styles/images/sp/edit.svg"
import editDisableIcon from "app/styles/images/sp/edit-disable.svg"
import RemarkModal from "app/components/normal/RemarkModal"
import { PREPARE_RUN, RUNNING } from 'app/utils/const'

const ObserverTable = observer(({ task, taskDetail, arrayPgtDataManageDetail, reportList, rowIndexInCard, index }) => {
  const columns = [
    {
      title: "关系",
      dataIndex: "relationName",
      key: "history-relationName",
      width: "14.6%",
      render: (text, record, index) => {
        const obj = {
          children: text,
          props: {
            rowSpan: 1
          },
        }
        let endIndex

        // 相同样本名的数量
        const sameCount = task.datas.filter(item => {
          endIndex = index
          return item.relationName === text
        }).length

        // 这个样本名的起始index
        const startIndex = task.datas.findIndex(item =>
          item.relationName === text
        )

        /*
         * 如果相同样本名的数量大于1
         * 1. 第一个做单元格合并
         * 2. 其余设置rowSpan为0
         * 不大于1正常渲染即可
         */
        if (sameCount > 1 && index <= endIndex) {
          if (index === startIndex) {
            obj.props.rowSpan = sameCount
          } else {
            obj.props.rowSpan = 0
          }
        }

        return obj
      }
    },
    {
      title: "文件名称",
      dataIndex: "filename",
      key: "history-filename",
      width: "28.97%",
      render: (text) => {
        const { front, end } = disposeFilename(text)

        return (
          <MaterialTip
            title={text}>
            <Row className="filename" type="flex">
              <div className="ellipsis filename-front">
                {front}
              </div>
              <div className="filename-end">{end}</div>
            </Row>
          </MaterialTip>
        )
      }
    },
    {
      title: "基因",
      dataIndex: "genes",
      key: "history-sampleName",
      width: "19.84%",
      render: (text) => {
        return (
          <MaterialTip
            title={text.toString()}
          >
            <div className="sample-name ellipsis">
              <Highlighter
                highlightClassName="lightlight"
                highlightStyle={{ fontWeight: "normal" }}
                searchWords={highlightable(text.toString(), '') ? [text.toString()] : []}
                textToHighlight={text.toString() || ""}
              />
            </div>
          </MaterialTip>
        )
      }
    }
  ]
  return (
    <Table
      className="children-table"
      columns={columns}
      rowKey={record => record.id + "datas"}
      dataSource={task.datas.slice()}
      pagination={false}
    />
  )
})

@inject("arrayPgtDataManageDetail") @observer
class Index extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showDeleteModal: false,
      remarksModalShowed: false,
      showEditModal: false,
      dataSingle: {},
      editedHistory: [],
      showHistory: false
    }

    this.columns = []
  }

  toggleHistory = () => {
    const { showHistory } = this.state
    const { arrayPgtDataManageDetail } = this.props

    this.setState({
      showHistory: !showHistory
    })

    arrayPgtDataManageDetail.getHistoryTableData()
      .catch(
        err => {
          message.error(err.message)
        }
      )
  }

  closeModal = (modal, cb) => {
    this.setState({
      [modal]: false
    })
    if (typeof cb === "function") {
      cb()
    }
  }

  showRemarksModal = (record) => {
    this.setState({
      remarksModalShowed: true,
      dataSingle: record
    })
  }

  expandedRowRender = (task) => {
    const {
      arrayPgtDataManageDetail,
      index,
    } = this.props
    return (
      <ObserverTable
        arrayPgtDataManageDetail={arrayPgtDataManageDetail}
        task={task}
        index={index} />
    )
  }

  toggleTaskTableRowExpand = (expanded, { id }) => {
    const {
      arrayPgtDataManageDetail: { getTaskDatas, setTaskDatas }
    } = this.props
    if (expanded) {
      getTaskDatas(id)
        .then(
          res => {
            setTaskDatas(id, res)
          },
          err => new Promise(function (resolve, reject) {
            message.error(err.message)
          })
        )
    }
  }

  updateRemarks = (remark) => {
    const { arrayPgtDataManageDetail: { updateRemarks } } = this.props
    const { dataSingle } = this.state
    updateRemarks(dataSingle, remark)
      .then(
        res => {
          dataSingle.remark = remark
          this.setState({
            remarksModalShowed: false
          })
          message.success("修改报告备注成功")
        },
        err => {
          message.error(err.message)
        }
      )
  }

  checkOperatable = (record) => {
    return record.state !== RUNNING && record.state !== PREPARE_RUN
  }

  previewReport = (reportId) => window.open(`/jab/array-pgt/${reportId}/preview`)

  render() {
    let {
      arrayPgtDataManageDetail: {
        historyTableData
      }
    } = this.props
    const {
      showHistory,
      remarksModalShowed,
      dataSingle
    } = this.state
    const extendBtnClass = cx({
      "close-btn": showHistory,
      "extend-btn": !showHistory
    })
    const tableClass = cx({
      "run-history-table": true,
      "close": !showHistory,
    })
    this.columns = [
      {
        title: (<div className="ta-c">任务ID</div>),
        dataIndex: "id",
        width: "20.97%",
        render: (text) => <div className="ta-c">{text}</div>
      }, {
        title: (<div className="ta-c">运行应用</div>),
        dataIndex: "appName",
        width: "9.62%",
        render: (text) => <div className="ta-c">{text}</div>
      }, {
        title: (<div className="ta-c">应用版本</div>),
        dataIndex: "appVersion",
        width: "9.62%",
        render: (text) => <div className="ta-c">{text}</div>
      }, {
        title: (<div className="ta-c">开始运行时间</div>),
        dataIndex: "startTime",
        width: "22.75%",
        render: (text) => <div className="ta-c">{text}</div>
      }, {
        title: (<div className="ta-c">计算时间</div>),
        dataIndex: "computingTime",
        width: "10.62%",
        render: (text) => <div className="ta-c">{text}</div>
      }, {
        title: (<div className="ta-c">报告备注</div>),
        dataIndex: "remark",
        width: "20.62%",
        render: (text) =>
          <MaterialTip
            title={text}
          >
            <div className="ta-c ellipsis">{text}</div>
          </MaterialTip>
      }, {
        title: (<div className="ta-c">运行状态</div>),
        dataIndex: "state",
        width: "13.7%",
        render: (state, record) => {
          switch (state) {
            case 0:
              return (
                <div className="ta-c">
                  <button className="pre-run">准备运行</button>
                </div>
              )
            case 1:
              return (
                <div className="ta-c">
                  <button className="running">正在运行</button>
                </div>
              )
            case 2:
              return (
                <div className="ta-c">
                  <button className="report-view" onClick={() => this.previewReport(record.reportId)}>查看报告</button>
                </div>
              )
            case 3:
              return (
                <MaterialTip
                  title="请将任务ID发送至管理员">
                  <div className="ta-c">
                    <button className="run-fail">运行失败</button>
                  </div>
                </MaterialTip>
              )
            default:
              break
          }
        }
      }, {
        title: (<div className="ta-c">操作</div>),
        dataIndex: "oprator",
        width: 50,
        render: (text, record, index) => {
          const operatable = this.checkOperatable(record)
          let imgClass = cx({
            "cursor-p": true,
            "disable": !operatable
          })
          let editIcon = operatable
            ? editAbleIcon
            : editDisableIcon

          return (
            <Row className="table-oprator ta-c" type="flex" justify="center" align="middle">
              <img
                className={imgClass}
                alt="编辑"
                src={editIcon}
                onClick={() => this.showRemarksModal(record)} />
            </Row>
          )
        }
      }
    ]

    return (
      <div>
        <div className="run-history wrapper-box">
          <Row type="flex" justify="start" align="middle" className="subtitle history">
            <i></i>
            <b>运行历史</b>
            <div className="line"></div>
            <button onClick={this.toggleHistory} className={extendBtnClass}>
              {showHistory ? "收起" : "展开"}
            </button>
          </Row>
          <Table
            className={tableClass}
            columns={this.columns}
            rowKey={record => record.id}
            dataSource={historyTableData.slice()}
            pagination={false}
            onExpand={this.toggleTaskTableRowExpand}
            expandedRowRender={this.expandedRowRender}
            expandIconAsCell={false}
          />
        </div>

        {/* 编辑modal */}

        {remarksModalShowed &&
          <RemarkModal
            visible
            action={this.updateRemarks}
            data={dataSingle}
            onCancel={this.closeModal}
          />
        }
      </div>
    )
  }
}

export default Index



// WEBPACK FOOTER //
// ./src/app/pages/arrayPgt/data_manage_detail/containers/HistoryTable.js